import { URL } from "../../api/Api";
import { catchError, GET, POST, PUT } from "../axios/Axios";

export const AssistCountCall = async (id) => {
  try {
    const response = await PUT(`${URL}/customers/ai_assist/usage/${id}`, "");
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

//Klarity
export const KlarityGetCall = async () => {
  try {
    const response = await GET(`${URL}/customers/klarity/daily-jobs`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const NewKlarityFileUpload = async (payload) => {
  try {
    const response = await POST(`${URL}/customers/klarity/daily-jobs`, payload);
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const NewKlarityChatBotPOST = async (payload) => {
  try {
    const response = await POST(
      `${URL}/chatbot/klarity-daily-jobs/chat`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};
